import { OptionItem } from './aiAssistantModel'

type Props = {
  options: OptionItem[]
  disabled: boolean
  // When provided, the list is a controlled picker (the question-set pager):
  // the matching option is highlighted and exposed via aria-pressed. When
  // omitted, the list is fire-and-send (the standalone OptionSelect).
  selectedId?: string | null
  onSelect: (option: OptionItem) => void
}

/**
 * The presentational core of an option question: a numbered button list.
 * Owns no state — the parent decides what selecting an option means (send it
 * as a message, or record it as the current page's answer).
 */
const OptionList = ({ options, disabled, selectedId, onSelect }: Props) => {
  const controlled = selectedId !== undefined

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      {options.map((option, i) => {
        const selected = controlled && selectedId === option.id
        return (
          <button
            key={option.id}
            type="button"
            disabled={disabled}
            aria-pressed={controlled ? selected : undefined}
            onClick={() => onSelect(option)}
            style={{
              display: 'flex',
              alignItems: 'baseline',
              gap: 8,
              textAlign: 'left',
              padding: '8px 12px',
              borderRadius: 8,
              border: selected ? '1px solid #1677ff' : '1px solid #d9d9d9',
              background: selected ? '#e6f4ff' : '#fff',
              cursor: disabled ? 'default' : 'pointer',
              opacity: disabled ? 0.6 : 1,
              font: 'inherit',
            }}
          >
            <span style={{ fontWeight: 600, color: '#888' }}>{i + 1}.</span>
            <span>
              <span style={{ fontWeight: 500 }}>{option.label}</span>
              {option.description && (
                <span style={{ display: 'block', fontSize: 12, color: '#888' }}>
                  {option.description}
                </span>
              )}
            </span>
          </button>
        )
      })}
    </div>
  )
}

export default OptionList
